export default __webpack_public_path__ + "static/media/img-slider-banpu-3.3853f72b.png";